import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { fetchCurrentTerm } from "../../redux/slices/term";
import { AllTerms } from "../../configs/AllTerms";
import { AllSessions } from "../../constants/AllSessions";
import AdminBatchUploadModal from "./AdminBatchUploadModal";

export default function UploadResults() {
  const dispatch = useDispatch();
  const [termName, setTermName] = useState("");
  const [session, setSession] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);

  useEffect(() => {
    dispatch(fetchCurrentTerm())
      .unwrap()
      .catch((error) => console.log(error));
  }, [dispatch]);

  const handleOpenModal = () => {
    if (!session || !termName) {
      alert("Please select a Term and Session before proceeding.");
      return;
    }
    setShowUploadModal(true);
  };

  return (
    <>
      <Page className="py-5">
        <div className="d-flex flex-row justify-content-between container align-items-center">
          <div>
            <h4>Upload Batch Results</h4>
            <p>
              Select a Session and Term, then open the Batch Upload wizard to
              upload a massive CSV for an entire school section.
            </p>
          </div>
        </div>

        <div className="select-wrapper d-flex flex-row flex-wrap p-3 px-4 mt-5 justify-content-start gap-3 align-items-end">
          <div className="d-flex flex-column gap-1">
            <div>
              <h6>Session</h6>
            </div>
            <select
              value={session}
              onChange={(e) => setSession(e.target.value)}
            >
              <option value="" disabled>
                Select Session
              </option>
              {AllSessions?.map((opt, index) => (
                <option key={index} value={opt.code}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>

          <div className="d-flex flex-column gap-1">
            <div>
              <h6>Term</h6>
            </div>
            <select
              value={termName}
              onChange={(e) => setTermName(e.target.value)}
            >
              <option value="" disabled>
                Select Term
              </option>
              {AllTerms?.map((opt, index) => (
                <option key={index} value={opt.code}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={handleOpenModal}
            className="check-btn btn btn-primary text-white"
          >
            <i className="fa-solid fa-upload me-2"></i> Open Batch Upload
          </button>
        </div>

        <Wrapper className="d-flex flex-column py-5 mt-5">
          <div className="text-center d-flex flex-column mt-4 text-muted">
            <h4 className="m-0">
              <i className="fa-solid fa-file-csv fs-1 mb-3 d-block"></i>
            </h4>
            <p>
              The Batch Upload feature handles placing hundreds of students into
              their correct current classes automatically. <br />
              To view the successfully processed results, navigate to the{" "}
              <strong>Results &gt; View Results</strong> tab.
            </p>
          </div>
        </Wrapper>
      </Page>

      <AdminBatchUploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        session={session}
        termName={termName}
      />
    </>
  );
}

const Wrapper = styled.div`
  background-color: #f5f5f5 !important;
`;

const Page = styled.div`
  .select-wrapper {
    width: 100%;
    align-items: center;
    width: fit-content;
    select {
      width: 200px !important;
      padding: 10px;
      border: 1px solid grey;
      color: grey;
      border-radius: 10px;
      background: transparent;
    }
    h6 {
      font-weight: 500 !important;
      font-size: 17px;
      margin: 0 !important;
    }
  }

  .check-btn {
    padding: 10.5px 20px;
    border-radius: 10px;
  }

  h4,
  p {
    margin: 0;
  }
  p {
    font-weight: 300;
  }
`;
